import { useMovieAssetsApi } from "../../../../assets/list/movies/api/useMovieAssetsApi";
import { cacheRequests } from "../../../utils/cacheRequests";
import { GetSingleAncillaryResponse } from "../../catalogue-api/ancillary/GetSingleAncillaryResponse";
import { useCatalogueAncillarySearchApi } from "../../catalogue-api/ancillary/useCatalogueAncillarySearchApi";
import { GetMovieByIdResponse } from "../../catalogue-api/movie/GetMovieByIdResponse";
import { GetSingleTvSeriesResponse } from "../../catalogue-api/tv-api/GetSingleTvSeriesResponse";
import { useCatalogueTvApi } from "../../catalogue-api/tv-api/useCatalogueTvApi";
import { GetFileRecordDetailsRequest } from "./details/GetFileRecordDetailsRequest";
import { GetFileRecordDetailsResponse } from "./details/GetFileRecordDetailsResponse";
import { useFileRecordApi } from "./useFileRecordApi";

const getFileRecordDetailsCache = cacheRequests<GetFileRecordDetailsResponse>();
const getMovieByIdCache = cacheRequests<GetMovieByIdResponse>();
const getTvSeriesByIdCache = cacheRequests<GetSingleTvSeriesResponse>();
const getAncillaryByIdCache = cacheRequests<GetSingleAncillaryResponse>();

export const useCachedFileRecordsApi = () => {
    const { getFileRecordDetails } = useFileRecordApi();

    const { getMovieById } = useMovieAssetsApi();
    const { getSingleTvSeries } = useCatalogueTvApi();
    const { getSingleAncillary } = useCatalogueAncillarySearchApi();

    const ttlMs = 20000;

    const getCachedFileRecordDetails = async (
        request: GetFileRecordDetailsRequest
    ): Promise<GetFileRecordDetailsResponse> => {
        return getFileRecordDetailsCache.getRequest({
            requestFn: () => getFileRecordDetails(request),
            key: `file-record-details-${request.fileRecordId}`,
            ttlMs
        });
    };

    const getCachedMovieById = async (movieId: string): Promise<GetMovieByIdResponse> => {
        return getMovieByIdCache.getRequest({
            requestFn: () => getMovieById(movieId),
            key: `movie-${movieId}`,
            ttlMs
        });
    };

    const getCachedTvSeriesById = async (tvSeriesId: string): Promise<GetSingleTvSeriesResponse> => {
        return getTvSeriesByIdCache.getRequest({
            requestFn: () => getSingleTvSeries(tvSeriesId),
            key: `tv-series-${tvSeriesId}`,
            ttlMs
        });
    };

    const getCachedAncillaryById = async (ancillaryId: string): Promise<GetSingleAncillaryResponse> => {
        return getAncillaryByIdCache.getRequest({
            requestFn: () => getSingleAncillary(ancillaryId),
            key: `ancillary-${ancillaryId}`,
            ttlMs
        });
    };

    return {
        getCachedFileRecordDetails,
        getCachedAncillaryById,
        getCachedTvSeriesById,
        getCachedMovieById
    };
};
